var _templateObject = _taggedTemplateLiteralLoose(['\n  align-items: center;\n  background-color: ', ';\n  color: ', ';\n  display: flex;\n  justify-content: center;\n  width: ', ';\n  max-width: 100vw;\n  min-height: ', ';\n  opacity: ', ';\n  padding: ', ';\n  position: absolute;\n\n  h1,h2,h3,h4,h5,h6,p,li,a {\n    color: ', ';\n    margin-top: 0px;\n    margin-bottom: 0px;\n  }\n'], ['\n  align-items: center;\n  background-color: ', ';\n  color: ', ';\n  display: flex;\n  justify-content: center;\n  width: ', ';\n  max-width: 100vw;\n  min-height: ', ';\n  opacity: ', ';\n  padding: ', ';\n  position: absolute;\n\n  h1,h2,h3,h4,h5,h6,p,li,a {\n    color: ', ';\n    margin-top: 0px;\n    margin-bottom: 0px;\n  }\n']);

function _taggedTemplateLiteralLoose(strings, raw) {
  strings.raw = raw;
  return strings;
}

import React, { Component, Fragment } from 'react';
import styled from 'styled-components';
var Container = styled.div(_templateObject, function (props) {
  return props.backgroundcolor || '#000000';
}, function (props) {
  return props.color || '#ffffff';
}, function (props) {
  return props.width || '50vw';
}, function (props) {
  return props.height || '50vh';
}, function (props) {
  return props.opacity || '0.7';
}, function (props) {
  return props.padding || '2rem';
}, function (props) {
  return props.color || '#ffffff';
});

var Overlay = function Overlay(props) {
  return React.createElement(Container, props, props.children);
};

export default Overlay;